import React from 'react';
import Hero from '../components/Hero';
import FeaturedProducts from '../components/FeaturedProducts';
import WhyUs from '../components/WhyUs';
import LoanCalculator from '../components/LoanCalculator';
import Testimonials from '../components/Testimonials';
import TopHeader from '../components/TopHeader';

function Home() {
  return (
    <div>
      {/* <TopHeader /> */}
      <Hero />
      <FeaturedProducts />
      <WhyUs />
      <LoanCalculator />
      <Testimonials limit={3} />
      <style>
        {`
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.6s ease-out forwards;
            willChange: transform, opacity;
          }
          .backdrop-blur-md {
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .hover\\:scale-105, .hover\\:shadow-lg, .group-hover\\:opacity-50, .group-hover\\:translate-x-1, .group-hover\\:border-[--primary-red] {
              animation: none !important;
              transform: none !important;
              opacity: 1 !important;
              transition: none !important;
            }
          }
          :root {
            --primary-blue: #2F498C;
            --primary-red: #843345;
            --primary-red-dark: #672737;
          }
          .bg-primary-blue {
            background-color: var(--primary-blue);
          }
          .bg-primary-red {
            background-color: var(--primary-red);
          }
          .text-primary-blue {
            color: var(--primary-blue);
          }
          .text-primary-red {
            color: var(--primary-red);
          }
          .hover\\:bg-primary-blue:hover {
            background-color: var(--primary-blue);
          }
          .hover\\:bg-primary-red:hover {
            background-color: var(--primary-red);
          }
          .hover\\:text-primary-red:hover {
            color: var(--primary-red);
          }
          .hover\\:shadow-primary-red\\/30:hover {
            --tw-shadow-color: rgba(132, 51, 69, 0.3);
            --tw-shadow: var(--tw-shadow-colored);
          }
          .border-primary-blue\\/10 {
            border-color: rgba(47, 73, 140, 0.1);
          }
          .border-primary-blue\\/50 {
            border-color: rgba(47, 73, 140, 0.5);
          }
          .group-hover\\:text-primary-red:hover {
            color: var(--primary-red);
          }
          .group-hover\\:border-[--primary-red]:hover {
            border-color: var(--primary-red);
          }
          .focus\\:ring-primary-blue:focus {
            --tw-ring-color: var(--primary-blue);
          }
        `}
      </style>
    </div>
  );
}

export default Home;